"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fluxible_router_1 = require("fluxible-router");
class TagsWidgetProps {
}
class TagsWidget extends React.Component {
    render() {
        return (React.createElement("div", { className: 'well' },
            React.createElement("h4", null, "Blog Tags"),
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'col-lg-6' },
                    React.createElement("ul", { className: 'list-unstyled' }, this.props.data.queryData.map((tag) => {
                        return (React.createElement("li", { key: tag },
                            React.createElement(fluxible_router_1.NavLink, { preserveScrollPosition: true, href: '/blog?tag=' + tag }, tag)));
                    }))))));
    }
}
exports.default = TagsWidget;
